import React from 'react';
import { linkButtonArray } from '../../utils/data/LinksData';

function ClipsPageMainContainer() {
  return (
    <main role='main' className='sm:pt-4 lg:pt-12'>
      {/* Info */}
      {/* Cta */}
      <section className='grid justify-center mx-auto py-8 px-4 gap-y-4 w-fit'>
        {linkButtonArray.map((btn, index) => (
          <a
            key={index}
            href={btn.link}
            className={`flex items-center gap-3 cursor-pointer bg-colour1 border-2 border-solid border-colour5 hover:bg-colour2 neon_button px-6 py-2 w-full text-center text-colour5 hover:text-colour5 ${
              !btn.link ? 'hidden' : ''
            }`}
            aria-label={`Visit ${btn.text}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {btn.icon && <div className=''>{btn.icon}</div>}
            {btn.image && (
              <div className=''>
                <img src={btn.image} alt={`${btn.text} Icon`} className='w-4' />
              </div>
            )}
            <div className='text-center w-full font-meduim font-StencilW01 tracking-wider'>
              <span>{btn.text}</span>
            </div>
          </a>
        ))}
      </section>
      {/* <CallToActionOne /> */}

      {/* Follow me */}
      {/* <div className='py-12'>
        <FollowMeOnCta />
      </div> */}
    </main>
  );
}

export default ClipsPageMainContainer;
